import axios from 'axios'
import router from '@/router'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器
request.interceptors.response.use(
  response => {
    if (response.config.isDownload) {
      return response
    }
    // 判断业务状态码
    if (response.data.code !== 200) {
      // 创建一个错误对象，包含业务错误信息
      const error = new Error(response.data?.message || '操作失败')
      error.response = response
      return Promise.reject(error)
    }
    return response
  },
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      if (router.currentRoute.name !== 'Login') {
        router.push({ 
          name: 'Login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
    }
    return Promise.reject(error)
  }
)

export default request